module.exports = __webpack_public_path__ + "static/media/colicoli12.bfee8d68.webp";